module.exports = __webpack_public_path__ + "dc4840e8285e8db361e161abf9273761.pdf";